package com.essntl.core.utils.utils.loadingmanager

import org.koin.dsl.module

val loadingManagerModule get() =
    module {
        single<LoadingManager> { LoadingManagerImpl() }
    }